import React, { useState } from 'react';
import {
    Loader,
    objestados,
    DeleteIcon,
    deshabilitar,
    Dialogos
} from './index.js';
import {Box, Typography} from "@material-ui/core";
import { Button, Spinner } from '@material-tailwind/react';

import { useAfiliacion } from '../../hooks/useAfiliacion.js';
import Main from '../../../../componentes/Main.js';

import { Acta } from '../modulos/componentes/Acta';
import { FechaActa } from '../modulos/componentes/FechaActa';
import { Botones } from '../modulos/componentes/Botones';
import { PanelDatosGenerales } from '../modulos/componentes/PanelDatosGenerales';
import { ColumnasDinamicas } from '../modulos/componentes/ColumnasDinamicas.js';
import { FilasDinamicas } from '../modulos/componentes/FilasDinamicas.js';
import { PanelAdjuntosDinamico } from '../modulos/componentes/PanelAdjuntosDinamico.js';
import { ValidacionesCheckboxes } from '../modulos/componentes/ValidacionesCheckboxes';
import AbmIglesia from '../../../../abms/Abm-iglesia';

export const TR_AfiliacionNew = ({ id, cabecera, setData, usuario, snackbar, puedeEditarse, cambiarStatus,finalizar }) => {

    const {
        error, loading, loading2, procesando, datosDelTramite, status_actual_tramite,
        acta_regional, cargarActa, actaFile, setCargarActa, setActa_cdn, fechaACDN,
        handleChangeFechaACDN, inicioActualizacionTramite, actualizarTramite, touched, fechaActa,
        esPerfilTesoreria, refrescando, traerUrl, esPerfilContaduria, setActaFile,
        visualizarIglesia, setVisualizarIglesia, nuevoAnalitico, blanquearActa,
        cambiarAnalitico, cancelarBlanqueo, nuevoExtra1, iniciarBlanquearActa,
        cambiarExtra1, handleChangeAutorizacionCheck, autorizado_tesoreria, copiarLink
    } = useAfiliacion(cabecera, id, setData, usuario, snackbar);

    const [activeTab, setActiveTab] = useState('informacion_general');

    const sinCambiosPendientes = () => {
        return !(cambiarAnalitico && !nuevoAnalitico) && !(cambiarExtra1 && !nuevoExtra1);
    };

    if (error) return <div className="p-4 bg-red-50 text-red-700 rounded-lg"><p>{JSON.stringify(error)}</p></div>;
    
    if (loading || loading2 || procesando) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)] gap-3'>
                    <Spinner className="h-12 w-12 text-blue-500" />
                    <span className="font-semibold text-gray-600 text-sm">Cargando...</span>
                </div>
            </Main>
        );
    }
    
    if (!datosDelTramite) return <div className="p-8 text-center"><Spinner className="h-12 w-12 mx-auto text-blue-500" /><p className="text-gray-500 mt-2">Cargando solicitud...</p></div>;

    return (
        <div id="solicitud-proceso" className="w-full mx-auto space-y-4 antialiased text-gray-800">
            <Loader open={refrescando} />
            <div className="flex flex-col col-span-1 lg:col-span-7 bg-gray-50 border border-gray-200 rounded-md p-2  shadow-sm overflow-y-auto max-h-[500px]">
                {/*NOTE - Sólo se habilita cuando el perfil del usuario es tesorería (100) y el estado es "En tesorería" */}
                <div className='flex items-center'>
                    <ValidacionesCheckboxes 
                        estadoOcultoOConsolidado={deshabilitar(status_actual_tramite,[objestados.tesoreria.nombre],'no_encontrado') || !esPerfilTesoreria(usuario)} 
                        campo_check={autorizado_tesoreria}
                        label_checked="Autorizado por tesorería"
                        label_unchecked_autorizado="Confirmo la autorización de tesorería"
                        label_unchecked_no_autorizado="Autorización de tesorería pendiente"
                        handleChange={handleChangeAutorizacionCheck}
                    />
                   <p className="text-[11px] ml-2 font-semibold px-2 py-1 rounded-md border bg-blue-50/60 inline-flex items-center gap-1 select-none">
                        Sólo habilitado para perfil tesorería en estado es "En tesorería"
                   </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left items-start antialiased">
                    
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                valor:(
                                    <button
                                        type="button"
                                        className="inline-flex items-center gap-1.5 text-xs font-bold text-blue-600 hover:text-blue-800 bg-blue-50/40 hover:bg-blue-50 px-2.5 py-1.5 rounded-lg border border-blue-100 transition-colors duration-200 cursor-pointer select-none"
                                        title="Visualice los datos de la iglesia" 
                                        onClick={() => setVisualizarIglesia(true)}
                                    >
                                        <span>👁️</span>
                                        Visualizar iglesia
                                    </button>
                                ),
                                descripcion: 'Haga clic aquí para visualizar los datos de la iglesia'
                            }                                                               
                        ]}
                    />

                <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm space-y-4 h-full">
                    <p className="text-[11px] font-semibold bg-blue-50/60 px-2 py-1 rounded-md border border-amber-200/70 gap-1 select-none">
                        Sólo habilitado para perfil contaduría en estado es "En contaduría"
                    </p>
                    <Typography variant="small" color="blue-gray" className="font-bold uppercase tracking-wider text-xs border-b border-gray-200 pb-2 text-slate-500">
                        Archivos adjuntos 
                    </Typography>
                    <p>{fechaActa}</p>
                    {/*NOTE - Sólo se habilita cuando el perfil del usuario es contaduría (1) y el estado es "En contaduría" */}    
                    <PanelAdjuntosDinamico 
                        titulo="Acta Afip"
                        url={datosDelTramite?.acta_afip}
                        editando={cargarActa}
                        nuevoArchivo={actaFile}
                        setEditando={setCargarActa}
                        setNuevoArchivo={setActaFile}
                        traerUrl={traerUrl}
                        deshabilitado={!esPerfilContaduria(usuario) || deshabilitar(status_actual_tramite,[objestados.contaduria.nombre],'no_encontrado')}
                    />

                    {datosDelTramite?.acta_afip && !actaFile && !blanquearActa && esPerfilContaduria(usuario) && status_actual_tramite === objestados.contaduria.nombre &&(
                        <div className="flex items-center gap-3 pt-1 w-full justify-between sm:justify-start">
                            
                            <button 
                                type="button"
                                className="inline-flex items-center gap-1.5 text-xs font-bold text-red-500 hover:text-red-700 bg-red-50/50 hover:bg-red-50 px-2.5 py-1.5 rounded-lg border border-red-100 transition-colors duration-200 cursor-pointer"
                                title="Eliminar el acta de afip original y dejar en blanco" 
                                onClick={() => iniciarBlanquearActa(false)}
                            >
                                <DeleteIcon style={{ fontSize: 16 }} /> {/* Achicamos sutilmente el ícono para que no rompa la línea */}
                                Dejar en blanco el acta AFIP
                            </button>

                        
                        </div>
                    )}
                    {datosDelTramite?.acta_afip && blanquearActa && !actaFile && <Box>
                        <h3 className='color-red mb-2'>Cuando grabe los cambios el acta Afip será eliminado del trámite</h3>
                        <button className='font-semibold' onClick={()=>cancelarBlanqueo()}>Cancelar la eliminación del acta</button>
                    </Box>}             
                </div>
                </div>

            </div>

            <Botones
                sinCambiosPendientes={sinCambiosPendientes}
                touched={touched}
                inicioActualizacionTramite={inicioActualizacionTramite}
                actualizarTramite={actualizarTramite}
                cambiarStatus={cambiarStatus}
                finalizar={finalizar}
                puedeEditarse={puedeEditarse}
            />
            <Dialogos open={visualizarIglesia} 
                    titulo='Afiliación' 
                    closeHeader
                    fullscreen={true}
                    procesarCancelar = {()=>setVisualizarIglesia(false)}
                >
                <AbmIglesia usuario = {usuario} id_iglesia={datosDelTramite.iglesia.id} finalizarAltaOcopia={()=>setVisualizarIglesia(false)} esVisualizacion={true}/>    
            </Dialogos>            
        </div>
    );
};
